import api from '@/lib/api';
import { CampaignRequest, CampaignResponse, LeadImportRequest, LeadImportResponse } from '@/types/api';

export const campaignService = {
  async getCampaigns(): Promise<CampaignResponse[]> {
    const response = await api.get<CampaignResponse[]>('/campaigns');
    return response.data;
  },

  async getCampaign(id: string): Promise<CampaignResponse> {
    const response = await api.get<CampaignResponse>(`/campaigns/${id}`);
    return response.data;
  },

  async createCampaign(campaign: CampaignRequest): Promise<CampaignResponse> {
    const response = await api.post<CampaignResponse>('/campaigns', campaign);
    return response.data;
  },

  async updateCampaign(id: string, campaign: CampaignRequest): Promise<CampaignResponse> {
    const response = await api.put<CampaignResponse>(`/campaigns/${id}`, campaign);
    return response.data;
  },

  async deleteCampaign(id: string): Promise<void> {
    await api.delete(`/campaigns/${id}`);
  },

  async sendCampaign(id: string): Promise<void> {
    await api.post(`/campaigns/${id}/send`);
  },

  async importLeads(importData: LeadImportRequest): Promise<LeadImportResponse> {
    const formData = new FormData();
    formData.append('file', importData.file);
    formData.append('columnMapping', JSON.stringify(importData.columnMapping));

    const response = await api.post<LeadImportResponse>('/leads/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
};